import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'ddc-track-event';
import { useLabels, useRequestData } from 'wsm-common-data';
import {
	getVehicleObj,
	publishVehicleData
} from '../../../utilities/vehicleTracking';
import './ViewGalleryLink.scss';

/**
 * Builds a VDP URL with the openGallery query param appended.
 * Handles links that already contain query params.
 */
export const buildGalleryUrl = (link) => {
	if (!link) return '';
	const separator = link.includes('?') ? '&' : '?';
	return `${link}${separator}openGallery=true`;
};

/**
 * ViewGalleryLink — overlay variant only.
 *
 * Rendered INSIDE the last slide of the react-slick carousel.
 * The overlay backdrop uses pointer-events: none so swipe/drag still works;
 * the inner __text span uses pointer-events: auto so the link is clickable.
 */
const ViewGalleryLink = ({ link, uuid, tabIndex }) => {
	const labels = useLabels();
	const { widgetName, windowId } = useRequestData();

	const labelText = labels.get('VIEW_GALLERY') || 'View Gallery';
	const galleryUrl = buildGalleryUrl(link);

	const handleClick = () => {
		trackEvent(widgetName, windowId, {
			element: 'View Gallery link',
			result: 'Navigated to VDP gallery',
			uuid,
			vehicle: getVehicleObj(uuid)
		});
		publishVehicleData(uuid);
	};

	return (
		<a
			href={galleryUrl}
			tabIndex={tabIndex}
			className="view-gallery-link--overlay d-flex align-items-center justify-content-center position-absolute text-decoration-none"
			onClick={handleClick}
			data-testid="view-gallery-link"
		>
			<span className="view-gallery-link__text d-inline-flex align-items-center text-white font-weight-bold text-decoration-none ddc-font-size-large">
				{labelText}
				<i
					className="ddc-icon ddc-icon-chevron-right ml-3"
					aria-hidden="true"
				/>
			</span>
		</a>
	);
};

ViewGalleryLink.propTypes = {
	link: PropTypes.string.isRequired,
	uuid: PropTypes.string.isRequired,
	tabIndex: PropTypes.number
};

ViewGalleryLink.defaultProps = {
	tabIndex: null
};

export default ViewGalleryLink;
